import { useAuth } from '@iamexperiences/feature-auth';
import { useMutation, useQuery } from 'react-query';
import { settingsManager } from '../../shared/settings';
import { IVerifiedCredential } from './Credential.type';

export const useRetrievingCredential = () => {
  const { auth } = useAuth();
  const url = `${settingsManager.get('myAccountBackendUrl')}/api/issueVerifiedEmployeeCredential`;
  const clientId = settingsManager.getRequired('clientId');

  return useMutation(async (): Promise<IVerifiedCredential> => {
    const token = await auth.acquireToken({ scopes: [clientId] });

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw error;
    }

    const json = await response.json();
    return json as IVerifiedCredential;
  });
};

export const useEnableVerifyId = () => {
  const url = `${settingsManager.get('myAccountBackendUrl')}/api/canVerifiedIdBeIssued`;
  const clientId = settingsManager.getRequired('clientId');
  const { auth } = useAuth();
  return useQuery({
    queryKey: ['enableVerifyId'],
    queryFn: async () => {
      const token = await auth.acquireToken({ scopes: [clientId] });
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        // for below expected errors, backend will return 200 with detail reason inside for debugging if need. otherwise, 204 is return
        // 1. guest user, 2.feature's turn off on backend, 3. tenant is not onboard to verifyID
        if (response.status === 204) return true;

        return await response.json();
      }

      const error = await response.text();
      throw new Error(error);
    },
  });
};
